import { getAccountDetails as publicGetAccountDetails } from './email-marketing-v1-account-details-account-details.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getAccountDetails: MaybeContext<
  BuildRESTFunction<typeof publicGetAccountDetails> &
    typeof publicGetAccountDetails
> = /*#__PURE__*/ createRESTModule(publicGetAccountDetails);

export {
  Enum,
  BillingCycle,
  Rank,
  Product,
  Content,
  SenderReputation,
  Statistics,
  Action,
} from './email-marketing-v1-account-details-account-details.universal.js';
export {
  AccountDetails,
  Package,
  Quota,
  QuotaPeriod,
  Features,
  GetAccountDetailsRequest,
  GetAccountDetailsResponse,
  GetComplianceDetailsRequest,
  GetComplianceDetailsResponse,
  ComplianceDetails,
  ComplianceDetailsProductOptionsOneOf,
  EmailMarketingOptions,
  AutomationOptions,
  RestrictionReason,
  RestrictionReasonTypeOneOf,
  RespondRequest,
  SupportTicketData,
  RespondResponse,
} from './email-marketing-v1-account-details-account-details.universal.js';
export {
  EnumWithLiterals,
  BillingCycleWithLiterals,
  RankWithLiterals,
  ProductWithLiterals,
  ContentWithLiterals,
  SenderReputationWithLiterals,
  StatisticsWithLiterals,
  ActionWithLiterals,
} from './email-marketing-v1-account-details-account-details.universal.js';
